import { Component, ViewChild } from "@angular/core";
import { UsersService, AppTableComponent, TranslationManager, SearchModel, SearchResultModel, ActiveEmployeeModel, MessagesComponent } from "src/common";


@Component({
  selector: 'users-active-employees-select',
  templateUrl: 'users-active-employees-select.component.html'
})

export class UsersActiveEmployeesSelectComponent {
  constructor(private usersService: UsersService) { }

  @ViewChild('table') table: AppTableComponent;
  translationManager = TranslationManager;
  selectedId: number=-1;
  items: any[];
  show: boolean = false;
  resolve: any;

  requestId:number;
  cond:string;

  showModal(requestId:number=null,cond:string=null) : Promise<number> {
      this.show = true;

      this.requestId=requestId;
      this.cond=cond;

      this.table.onSearch = this.doSearch.bind(this);
      this.table.search();

	return new Promise((resolve) => {
	  this.resolve = resolve;
	})
  }

  doSearch(search: SearchModel) {

    if(this.cond==='opnboardmemberslist')
    {
      this.usersService.searchActiveEmployeesOpnBoardMembersList(search,this.requestId).then((result: SearchResultModel<ActiveEmployeeModel>) => {
        this.items = result.items;
        this.table.setTotalCount(result.totalCount);
    })
    }
    else
    {
      this.usersService.searchActiveEmployees(search).then((result: SearchResultModel<ActiveEmployeeModel>) => {
        this.items = result.items;
        this.table.setTotalCount(result.totalCount);
    })
    }

  }

  selectActiveEmployee(id: number,event) {
      if (event.target.checked) {
        this.selectedId = id;
      }
      else {
        this.selectedId = -1;
      }
  }

  close() {
    this.show = false;
    if (this.resolve) {
      this.resolve();
    }
  }

  getEmployeeById(id: number): ActiveEmployeeModel {
    let model: ActiveEmployeeModel = this.items.find((x => x.id == this.selectedId));
    return model;
  }

  submit() {
    if (this.selectedId == -1) {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Морате изабрати члана тима/одбора за одобрење набавке')]);
    }
    else {
      this.save();
    }
  }

  save() {

      this.show = false;
      if (this.resolve) {
          let model: ActiveEmployeeModel = this.items.find((x => x.id == this.selectedId));
          this.resolve(model);
      }
  }
}
